import { t } from '@/i18n/utils'

/**
 * 404 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  get pageNotFound() { return t('pageNotFound') },
  get goToHomePage() { return t('goToHomePage') },
} as const
